<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1102001000011ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 예금 상품 상세(개인정기예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>개인정기예금</h2>
            <!-- 개인정기예금 -->
          </div>
          <div class="description">
            <p>
              목돈을 일정기간동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 예금
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">최대 연</span>
              </div>

              <div class="percent">
                3.1%
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
                <span class="text">최대 연</span>
              </div>
              <div class="percent">
                3.6%
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>정기예금</dd>
            <dt>상품개요</dt>
            <dd>목돈을 일정기간동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 예금</dd>
            <dt>가입대상</dt>
            <dd>18세 이상 성인</dd>
            <dt>계약기간</dt>
            <dd>1개월, 3개월, 6개월, 12개월</dd>
            <dt>가입통화</dt>
            <dd>USD, KHR</dd>
            <dt>가입금액</dt>
            <dd>신규가입 시 최저 USD 1,000.00 이상</dd>
            <dt>금리 및 이율</dt>
            <dd>통화 : USD / KHR</dd>
          </dl>
          <div class="tbl-top-etc">(연이율, 세전, 단위%)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="2" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">예금이율</th>
              </tr>
              <tr>
                <th scope="col">USD</th>
                <th scope="col">KHR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1개월</th>
                <td>1.20</td>
                <td>1.70</td>
              </tr>
              <tr>
                <th scope="row">3개월</th>
                <td>2.00</td>
                <td>2.50</td>
              </tr>
              <tr>
                <th scope="row">6개월</th>
                <td>2.75</td>
                <td>3.20</td>
              </tr>
              <tr>
                <th scope="row">12개월</th>
                <td>3.10</td>
                <td>3.60</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· 중도해지이율 : 연 0.50%</p>
            <p>· 만기이후이율 : 없음</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>수수료</strong>
            <p>해당무</p>
          </div>

          <div class="info info-type4">
            <strong>가입방법</strong>
            <p>영업점가입, 인터넷 가입</p>
          </div>
          <div class="info info-type4">
            <strong>가입시 필요서류</strong>
            <p>ID 카드, 여권 등 실명확인증표</p>
          </div>
        </article>
      </div>
    </template>

    <!-- 영어 -->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Term Deposits-Individual(Resident)</h2>
            <!-- 개인정기예금 -->
          </div>
          <div class="description">
            <p>
              A temporary deposit product for a stable income by depositing savings for a fixed period of time
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">USD</span>
              </div>
              <div class="percent">
                Maximum 3.1% annually
              </div>
            </div>
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
              </div>
              <div class="percent">
                Maximum 3.6% annually
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Term Deposits</dd>
            <dt>About the products</dt>
            <dd>A temporary deposit product for a stable income by depositing savings for a fixed period of time</dd>
            <dt>Eligibilty</dt>
            <dd>Adults over 18 years old</dd>
            <dt>Contract Terms</dt>
            <dd>1 month, 3 months, 6 months, or 12 months</dd>
            <dt>Available currency</dt>
            <dd>USD, KHR</dd>
            <dt>Deposit amount</dt>
            <dd>To open an account, a minimum USD 1,000.00 deposit amount is required.</dd>
            <dt>Rates</dt>
            <dd>Currency : USD / KHR</dd>
          </dl>
          <div class="tbl-top-etc">(annual interest rate, pretax, unit : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="2" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">Savings interest rate</th>
              </tr>
              <tr>
                <th scope="col">USD</th>
                <th scope="col">KHR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1month</th>
                <td>1.20</td>
                <td>1.70</td>
              </tr>
              <tr>
                <th scope="row">3months</th>
                <td>2.00</td>
                <td>2.50</td>
              </tr>
              <tr>
                <th scope="row">6months</th>
                <td>2.75</td>
                <td>3.20</td>
              </tr>
              <tr>
                <th scope="row">12months</th>
                <td>3.10</td>
                <td>3.60</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· Interest rate for an early termination : 0.50% annually</p>
            <p>· Interest rate after the maturity : None</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>Fees</strong>
            <p>N/A</p>
          </div>

          <div class="info info-type4">
            <strong>How to apply</strong>
            <p>Apply at the branch, Apply Online</p>
          </div>
          <div class="info info-type4">
            <strong>Required documents for application</strong>
            <p>ID card, passport, identity verification, etc.</p>
          </div>
        </article>
      </div>
    </template>

    <!--한국어-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>ការសន្សំប្រាក់មានកាលកំណត់សំរាប់បុគ្គល(និវាសជន)</h2>
            <!-- 개인정기예금 -->
          </div>
          <div class="description">
            <p>
              ប្រាក់ច្រើនដែលបានបញ្ចូលក្នុងរយៈពេលមួយដែលបានកំនត់ក្នុងគោលបំនងទទួលបានអត្ថប្រយោជន៍ ក្នុងការបញ្ចូលនេះ។
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">USD</span>
              </div>
              <div class="percent">
                ក្នុងមួយឆ្នាំ 3.1% ជាអតិបរមា
              </div>
            </div>
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
              </div>
              <div class="percent">
                ក្នុង១ឆ្នាំ3.6% ជាអតិបរមា
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>ប្រភេទផលិតផល</dt>
            <dd>បា្រក់បញ្ញើមានពេលកំណត់</dd>
            <dt>មាតិកាផលិតផល</dt>
            <dd>ប្រាក់ច្រើនដែលបានបញ្ចូលក្នុងរយៈពេលមួយដែលបានកំនត់ក្នុងគោលបំនងទទួលបានអត្ថប្រយោជន៍ ក្នុងការបញ្ចូលនេះ។</dd>
            <dt>អតិថិជនគោលដៅ</dt>
            <dd>អ្នកដែលមានអាយុចាប់ពី១៨ឆ្នាំឡើងទៅ</dd>
            <dt>រយៈពេលកិច្ចសន្យា</dt>
            <dd>១ខែ ៣ខែ ៦ខែ ១២ខែ</dd>
            <dt>ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ</dt>
            <dd>USD, KHR</dd>
            <dt>ចំនួនទឹកប្រាក់ដែលស្នើសុំ</dt>
            <dd>ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD1,000.00</dd>
            <dt>អត្រាការប្រាក់</dt>
            <dd>រូបិយវត្ : USD / KHR</dd>
          </dl>
          <div class="tbl-top-etc">(ការប្រាក់ប្រចាំឆ្នាំ, បង់ពន្ធជាមុន, ខ្នាត : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="2" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">ការប្រាក់ក្នុងការបញ្ចូលប្រាក់</th>
              </tr>
              <tr>
                <th scope="col">USD</th>
                <th scope="col">KHR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">១ខែ</th>
                <td>1.20</td>
                <td>1.70</td>
              </tr>
              <tr>
                <th scope="row">៣ខែ</th>
                <td>2.00</td>
                <td>2.50</td>
              </tr>
              <tr>
                <th scope="row">៦ខែ</th>
                <td>2.75</td>
                <td>3.20</td>
              </tr>
              <tr>
                <th scope="row">១២ខែ</th>
                <td>3.10</td>
                <td>3.60</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· ការប្រាក់នៅពេលលុបចោលការសន្សំប្រាក់នៅពាក់កណ្តាល:ក្នុងមួយឆ្នាំ 0.50%</p>
            <p>· ការប្រាក់បន្ទាប់ពីផុតកំនត់: គ្មាន</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>កំរៃសេវា</strong>
            <p>គ្មាន</p>
          </div>

          <div class="info info-type4">
            <strong>របៀបចុះឈ្មោះ</strong>
            <p>ចុះឈ្មោះនៅសាខា, ចុះឈ្មោះតាមអ៊ីនធឺណិត</p>
          </div>
          <div class="info info-type4">
            <strong>តំរូវការឯកសារចុះឈ្មោះ</strong>
            <p>កាតID លិខិតឆ្លងដែន និងលេខអត្តសញ្ញាណប័ណ្ណ</p>
          </div>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
